import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import { Customer } from "../../../../data/entities";
import FormContainer from "../Content";
import ProductTableTab from "../Content/ProductOrdersTab";
import ProductList from "../Content/ProductList";

interface TabNavigationProps {
    validated: boolean;
    customerData: any;
    mergeCustomer: Function;
}

const TabNavigation = ({
    validated,
    customerData,
    mergeCustomer,
}: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: (
                <FormContainer
                    validated={validated}
                    customerData={customerData}
                    mergeCustomer={mergeCustomer}
                />
            ),
        },
        {
            label: "Đơn Hàng Sản Phẩm",
            labelEN: "product-orders",
            content: <ProductTableTab customerUUID={customerData.id} />,
        },
        {
            label: "Sản Phẩm",
            labelEN: "products",
            content: (
                <ProductList
                    products={customerData.products}
                    mergeProducts={mergeCustomer}
                />
            ),
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
